module.exports = __webpack_public_path__ + "img/timer.8afd3a68.svg";